<template>
  <div>
    <!-- Create account modal -->
    <b-modal
      id="create-account-modal"
      ref="createAccountModal"
      title="Create Account"
      hide-header-close
      @ok="createAccount"
    >
      <b-form @submit.prevent="createAccount">
        <b-form-group
          label="Account Name"
          label-for="account-name"
          :state="createAccountForm.accountNameState"
        >
          <b-form-input
            id="account-name"
            v-model="createAccountForm.accountName"
            :state="createAccountForm.accountNameState"
            aria-describedby="account-name-live-feedback"
            placeholder="Enter account name"
            required
          />
          <b-form-invalid-feedback id="account-name-live-feedback">
            Account name is required
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          label="Account Type"
          label-for="account-type"
          :state="createAccountForm.accountTypeState"
        >
          <b-form-select
            id="account-type"
            v-model="createAccountForm.accountType"
            :state="createAccountForm.accountTypeState"
            aria-describedby="account-type-live-feedback"
            :options="accountTypes"
            required
          />
          <b-form-invalid-feedback id="account-type-live-feedback">
            Account type is required
          </b-form-invalid-feedback>
        </b-form-group>
      </b-form>
    </b-modal>
    <b-nav-item-dropdown
      v-if="user.role === 'admin'"
      ref="dropdown"
      class="dropdown-notification mr-25"
      menu-class="dropdown-menu-media"
      left
    >
      <template #button-content>
        <b-button variant="outline-primary">
          {{ selectedAccount.label }}
        </b-button>
      </template>

      <!-- Header -->
      <li class="dropdown-menu-header">
        <div class="dropdown-header d-flex">
          <h4 class="notification-title mb-0 mr-auto">
            {{ $t('switch_account') }}
          </h4>
        </div>
      </li>

      <div v-if="user.role === 'admin'" class="d-flex align-items-center justify-content-end">
        <b-form-input
          v-model="queryParams"
          class="dropdown-search-bar"
          :placeholder="$t('areas_management.place_holders.search')"
          @input="filterAccounts"
        />
      </div>

      <div v-if="user.role === 'admin'" style="margin-left: 10px; margin-block: 5px;">
        <b-form-checkbox
          v-model="showMyAccountsOnly"
          :value="true"
          :unchecked-value="false"
          @change="separateAccounts()"
        >
          {{ $t('show_only_my_accounts') }}
        </b-form-checkbox>
        <b-form-checkbox
          v-model="showPassiveAccounts"
          :value="true"
          :unchecked-value="false"
          @change="separateAccounts()"
        >
          {{ $t('show_passive_accounts') }}
        </b-form-checkbox>
      </div>

      <!-- Notifications -->
      <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="scrollable-container media-list scroll-area"
        tagname="li"
      >
        <div style="position: absolute; left: 42.5%; top: 40%">
          <b-spinner v-if="loading" style="width: 60px; height: 60px;" />
        </div>
        <!-- Account Notification -->
        <b-link
          v-for="account in accounts"
          :key="account.value.id"
          @click="setAccount(account)"
        >
          <b-media :style="{opacity: loading ? 0 : 1}">
            <p class="media-heading">
              <span class="font-weight-bolder">
                {{ account.label }}
              </span>
            </p>
          </b-media>
        </b-link>
        <!-- create new account button-->
        <b-button
          v-if="user.email === 'ilmi@hoiwa.fi' || user.email === 'jama.ali@hoiwa.fi' || user.email === 'lari.juva@hoiwa.fi' || user.email === 'anni.kangasniemi@hoiwa.fi'"
          v-b-modal.create-account-modal
          variant="outline-primary"
          class="btn-block"
        >
          Create New Account
        </b-button>
      </vue-perfect-scrollbar>
    </b-nav-item-dropdown>
    <p v-else style="margin-top: 12px; font-size: 1.5rem; font-weight: 600;">{{ selectedAccount.label }}</p>
  </div>
</template>

<script>
import {
  BNavItemDropdown, BMedia, BLink, BButton, BModal, VBModal, BForm, BFormGroup, BFormInput, BFormSelect, BFormInvalidFeedback, BFormCheckbox, BSpinner,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import { db } from '@/shared/services/firebase'

export default {
  components: {
    BNavItemDropdown,
    BMedia,
    BLink,
    VuePerfectScrollbar,
    BModal,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormInvalidFeedback,
    BFormCheckbox,
    BSpinner,
  },
  directives: {
    Ripple,
    'b-modal': VBModal,
  },
  data() {
    return {
      createAccountForm: {
        accountName: '',
        accountNameState: null,
        accountType: '',
        accountTypeState: null,
      },
      accountTypes: [
        { text: 'Public', value: 'public' },
        { text: 'Private', value: 'private' },
      ],
      queryParams: '',
      accounts: this.$store.state.appAccount.accounts,
      showPassiveAccounts: false,
      showMyAccountsOnly: true,
      loading: false,
    }
  },
  computed: {
    selectedAccount() {
      return this.$store.state.appAccount.selectedAccount
    },
    user() {
      return this.$store.state.appAuth.authUser ? this.$store.state.appAuth.authUser : {}
    },
    areaGroups() {
      return this.$store.state.appAccount.areaGroups
    }
  },
  created() {
    this.separateAccounts()
  },
  methods: {
    async createAccount(e) {
      this.createAccountForm.accountNameState = null
      this.createAccountForm.accountTypeState = null

      if (!this.createAccountForm.accountName || this.createAccountForm.accountName.length < 1) {
        this.createAccountForm.accountNameState = false
      }
      if (!this.createAccountForm.accountType || this.createAccountForm.accountType.length < 1) {
        this.createAccountForm.accountTypeState = false
      }

      if (this.createAccountForm.accountName && this.createAccountForm.accountType && this.createAccountForm.accountName.length > 1 && this.createAccountForm.accountType.length > 1) {
        try {
          await this.$store.dispatch('appAccount/createAccount', {
          name: this.createAccountForm.accountName,
          accountType: this.createAccountForm.accountType,
          category: '',
          created: new Date(),
        })
        this.$refs.createAccountModal.hide()
        window.location.reload()
        } catch(err) {
          this.$refs.createAccountModal.hide()
        }
      } else {
        e.preventDefault()
      }  
      
    },
    async separateAccounts() {
      this.loading = false
      this.accounts = this.$store.state.appAccount.accounts
      if(this.showMyAccountsOnly && this.user.role === 'admin') {
        const myAreaGroup = this.areaGroups.find(group => group.id === this.user.id)
        if(myAreaGroup && myAreaGroup.accounts) {
          this.accounts = this.accounts.filter(item => myAreaGroup.accounts.includes(item.value.id))
        }
      }
      if(!this.showPassiveAccounts && this.user.role === 'admin') {
        this.loading = true
        const today = new Date()
        const threeMonthsBefore = new Date(today.setMonth(today.getMonth() - 3))
        const accounts = await Promise.all(this.accounts.map(async item => {
          const gigsCollection = await db
            .collection('gigs')
            .where('accountId', '==', item.value.id)
            .where('created', '>=', threeMonthsBefore)
            .limit(1)
            .get()
          
          return {
            ...item,
            isPassive: gigsCollection.empty,
          }
        }))

        this.loading = false
        this.accounts = accounts.filter(item => !item.isPassive)
      }
    },
    filterAccounts() {
      this.accounts = this.$store.state.appAccount.accounts.filter(item => item.label.toLowerCase().slice(0, this.queryParams.length).includes(this.queryParams.toLowerCase()))
    },
    setAccount(account) {
      this.$store.dispatch('appAccount/setSelectedAccount', account)
      this.$refs.dropdown.hide(true)
      window.location.reload()
    },
  },
  setup() {
    /* eslint-disable global-require */
    const notifications = [
      {
        title: 'Congratulation Sam 🎉',
        avatar: require('@hw-ui/assets/images/avatars/6-small.png'),
        subtitle: 'Won the monthly best seller badge',
        type: 'light-success',
      },
      {
        title: 'New message received',
        avatar: require('@hw-ui/assets/images/avatars/9-small.png'),
        subtitle: 'You have 10 unread messages',
        type: 'light-info',
      },
      {
        title: 'Revised Order 👋',
        avatar: 'MD',
        subtitle: 'MD Inc. order updated',
        type: 'light-danger',
      },
    ]
    /* eslint-disable global-require */

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    return {
      notifications,
      perfectScrollbarSettings,
    }
  },
}
</script>

<style>

</style>
